import './team-scouting.styles.scss';
import { DEFENSES, DEPTHS, OFFENSES, PACES, strategyLabel } from '@shared/strategy.js';

// Scouting: what a team usually runs (games run with each offense and
// defense, team.systemGames) and what it ran last time (team.strategy).
const TeamScouting = ({ team }) => {

    const games = team.systemGames;
    if (!games) return null;
    const usual = (cat, list) => Object.entries(games[cat] ?? {})
        .filter(([, n]) => n >= 1)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 2)
        .map(([key, n]) => `${strategyLabel(list, key)} (${Math.round(n)})`)
        .join(', ');
    const last = team.strategy;

    return (
        <div className='g-card team-scouting'>
            <h3>Scouting</h3>
            <dl className='scouting-list'>
                <dt>Offense</dt><dd>{usual('offense', OFFENSES) || '-'}</dd>
                <dt>Defense</dt><dd>{usual('defense', DEFENSES) || '-'}</dd>
                {last &&
                    <>
                        <dt>Last game</dt>
                        <dd>
                            {strategyLabel(OFFENSES, last.offense)} · {strategyLabel(DEFENSES, last.defense)} ·{' '}
                            {strategyLabel(PACES, last.pace)} pace · {strategyLabel(DEPTHS, last.depth)} rotation
                        </dd>
                    </>
                }
            </dl>
            <p className='meta'>Numbers are recent games run with each system.</p>
        </div>
    )
}

export default TeamScouting
